import getDirectusInstance from '#lib/directus/directus.js';
import { readItems } from '@directus/sdk';
import type { Season } from '#lib/schema-extension.js';
import getHockeydataInstance, { findOwnTeamId } from '#lib/hockeydata/hockeydata.js';
import { error } from '@sveltejs/kit';

export const load = async ({ fetch, params, url }) => {
	const directus = getDirectusInstance(fetch);

	const seasonSlug = params.wildcats ? params.wildcats + '/' + params.seasonId : params.seasonId;

	const season = (
		await directus.request<Season[]>(
			readItems('season', {
				filter: {
					status: url.searchParams.has('preview')
						? { _in: ['published', 'draft'] }
						: { _in: ['published'] },
					slug: { _eq: seasonSlug }
				},
				fields: ['*']
			})
		)
	)[0];

	if (!season) {
		error(404, 'Saison nicht gefunden');
	}

	const hockeydata = getHockeydataInstance(fetch);
	const hdSeason = await hockeydata.getDivisionInfo(season);

	const ownTeamId = findOwnTeamId(hdSeason.data.teams);
	const groupDivisionId = await hockeydata.getGroupDivisionId(season);
	const group = [hdSeason.data.divisionInfo, ...hdSeason.data.divisions].find(
		(division) => division.id.toString() === groupDivisionId
	);
	const groupTeams = group
		? hdSeason.data.teams.filter((team) => group.teams.includes(team.id))
		: hdSeason.data.teams;

	return {
		season,
		hdSeason,
		ownTeamId,
		groupTeams
	};
};
